import { useNeuroMessages } from '@ignitesales/neuro-application/src/neuro-guide/components';

const useProductUrl = () => {

  const messageContext = useNeuroMessages();
  

  const getProductUrlByRuleMatch = (matched, urlMapper) => {
    if(!!matched?.value?.length) {
      let key = matched.value[0];
      let urlMsgKey = urlMapper[key];
      return messageContext.getMessage(urlMsgKey);
    } 
  }

  return {
    getProductUrlByRuleMatch
  }
}

export default useProductUrl; 